<template>
  <portlet
      :icon="'fal fa-at'"
      :title="'Maillijst'"
      :actionsBlock="true"
  >
    <template v-if="Can(rights.MAILING_LIST_ADD)" slot="actionsBlock">
      <button class="btn btn-primary" @click="addEmail()">
        <i class="fas fa-plus mr-2"></i> Toevoegen
      </button>
    </template>

    <template v-if="Can(rights.MAILING_LIST_VIEW)" slot="portletBody">
      <datatables
          :tableClass="'mailing-list-overview'"
          :rows="getMailingListOfType('website')"
          :columns="getColumns()"
          tableID="pools-overview-dt"
          routerLinkClass="dt-router-link"
          :tableInitOptions="tableInitOptions"
          :deleteFunction="deleteEmailFromList"
          deleteClass="delete"
      ></datatables>
    </template>
  </portlet>
</template>


<script>
import {mapGetters} from "vuex";
import { Can } from "../../../permission/ability";
import { RIGHTS } from "../roles/rights";

export default {
  props: [],
  components: {},
  data() {
    return {
      rights: '',
      tableInitOptions: {
        destroy: true,
        responsive: true,
        details: false,
        select: true,
        bAutoWidth: false,
        language: {
          searchPlaceholder: 'Zoeken...',
          sProcessing: 'Bezig...',
          sLengthMenu: '_MENU_',
          sZeroRecords: 'Geen resultaten gevonden',
          sInfo: '_START_ tot _END_ van _TOTAL_ resultaten',
          sInfoEmpty: 'Geen resultaten om weer te geven',
          sInfoFiltered: ' (gefilterd uit _MAX_ resultaten)',
          sInfoPostFix: '',
          sSearch: '',
          sEmptyTable: 'Geen resultaten aanwezig in de tabel',
          sInfoThousands: '.',
          sLoadingRecords: 'Een moment geduld aub - bezig met laden...',
          oPaginate: {
            sFirst: 'Eerste',
            sLast: 'Laatste',
            sNext: 'Volgende',
            sPrevious: 'Vorige'
          },
          oAria: {
            sSortAscending: ': activeer om kolom oplopend te sorteren',
            sSortDescending: ': activeer om kolom aflopend te sorteren'
          }
        }
      }
    };
  },
  methods: {
    Can,
    async deleteEmailFromList(document) {
      this.$store.dispatch('mailinglist/delete', document.id);
      this.$toasted.global.successRequest({
        message: "Emailadres is verwijderd."
      });
    },
    async addEmail() {
      const result = await this.$swal.fire({
        title: 'E-Mailadres toevoegen',
        html:
            '<label for="new-maillist-email">Emailadres</label><input  type="email" id="new-maillist-email" class="swal2-input">' +
            '<label for="new-maillist-description">Omschrijving</label><input id="new-maillist-description" placeholder="Optioneel" class="swal2-input">',
        focusConfirm: false,
        preConfirm: () => {
          return {
            email: document.getElementById('new-maillist-email').value,
            description: document.getElementById('new-maillist-description').value
          }
        }
      });
      if (result.value.email) {
        this.$store.dispatch('mailinglist/insert', {
          email: result.value.email,
          description: result.value.description,
          type: 'website',
          created_at: new Date(),
          added_by: this.$store.getters.getUserData,
          department: this.$store.getters.getUserData.selectedDepartment
        });
        this.$toasted.global.successRequest({
          message: "Emailadres is toegevoegd."
        });
      }
    },
    getColumns() {
      let self = this;
      return [
        {
          orderable: true,
          data: 'email', name: 'E-mailadres', visible: true, searchable: true, responsivePriority: 1
        },
        {
          orderable: true,
          data: null, name: 'Omschrijving', visible: true, searchable: true, responsivePriority: 1,
          render(data) {
            return data.description ? data.description : data.email;
          }
        },
        {
          data: null, name: 'Opties', orderable: false, responsivePriority: 1,
          render(data) {
            var options = '';

            if(Can(RIGHTS.MAILING_LIST_DELETE)) {
                options += '<a class="delete action-icon" data-id="' + data.id + '"><i title="Verwijder" class="far fa-trash-alt delete"></i></a>';
            }
            return options;
          }
        },
      ]
    },

  },
  watch: {},
  computed: {
    ...mapGetters('mailinglist', ['getMailingListOfType']),
  },
  created() {
    this.rights = RIGHTS;
  }
};
</script>
<style lang="scss">

</style>